export const LIST_CONFIG = {
    height: 303,
    heightSearchState: 132,
    rowHeight: 44,
    width: 650,
};

export const TOOLTIP_WIDTH = 155;

export const TIMEOUT_UPDATE_SAVED_KW = 5000;
export const MAX_PASTE_KW_LIMIT = 1000;

export const REGEX_PASTE_KW = /\r\n?|\n|\s*,\s*/;

export const DROPDOWN_CONFIG = {
    width: 360,
    dropdownPopupHeight: 157,
};

export const PLACEHOLDER_SIZE = {
    width: 307,
    height: 30,
};
